<script setup lang="ts">
import { ref } from "vue";
import ArticleModal from "../articles/ArticleModal.vue";
import type { Article } from "@/types/articles.types";

const showArticle = ref(false);

defineProps<{
  article: Article;
  title: string;
}>();
</script>

<template>
  <div>
    <button @click="showArticle = !showArticle" class="btn btn-link p-0">
      <small> {{ title }} </small>
    </button>

    <ArticleModal v-model="showArticle" :article="article" />
  </div>
</template>

<style lang="scss" scoped></style>
